import type { AxiosResponse } from 'axios';

import { ADMIN, baseRoutesV2, baseUrl } from '@/api/config';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type { IOrganization } from './types';

export const getAll = ()
  : Promise<void | AxiosResponse<string []>> => axiosInstance({
  url: ROUTES.ORGS,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const getAllV2 = ()
  : Promise<void | AxiosResponse<IOrganization[]>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutesV2}${ADMIN}`,
  url: ROUTES.ORGS,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const update = (id: string, org: Omit<IOrganization, 'id'>)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.ORGS}/${id}`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data: org,
});

export const remove = (id: string)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.ORGS}/${id}`,
  method: 'DELETE',
  headers: {
    authorization: true,
  },
});
